<div class="block-inline">

  <div [ngClass]="{
      'not-contact-info':!(competition.Address || provideEmail(competition) || competition?.Links.Web)
    }" class="container">
    <div *ngIf="competition?.Address?.Latitude != undefined; else notFound" style="width: 100%; max-width: 1000px;">
      <div class="container__map">
        <div style="height: 300px; max-height: 380px" leaflet [leafletOptions]="optionsMap">
          <div [leafletLayers]="layers"></div>
        </div>
      </div>
    </div>

    <ng-template #notFound>
      <img class="container__not-found" style="max-height: 380px;"
        src="../../../../../../modules/custom/wa_angular/app/assets/images/assets-maps/location_not_found.png" />
      <div class="container__centered"><strong>{{'location_not_available' | transloco}}</strong></div>
    </ng-template>

  </div>


  <div *ngIf="competition?.Address || provideEmail(competition) || competition?.Links?.Web" class="contact__block">
    <h2>{{'contact_info' | transloco}}</h2>
    <div class="address" *ngIf="competition.Address">
      <i class="icon--address"></i>{{'Address' | transloco}}: {{competition?.Venue}}, {{competition?.Address?.Address}},
      {{competition?.Address?.Place}}, {{competition?.Address?.Zip}}, {{competition?.Address?.State}} {{
      competition?.Address?.ContryName}}
    </div>
    &nbsp;
    <div class="phone" *ngIf="competition?.Links?.Phone || competition?.Links?.Mobile">
      <a class="icon--phone" *ngFor="let phone of provideTelephone(competition)">{{phone}}</a>
    </div>
    &nbsp;

    <div class="mail" *ngIf="provideEmail(competition)">
      <div class="mail">
        <a [href]="'mailto:'  + email" class="icon--email" *ngFor="let email of provideEmail(competition)">{{email}}</a>
      </div>
    </div> &nbsp;

    <div class="web" *ngIf="competition?.Links?.Web">
      <a class="icon--web" [href]="competition?.Links?.Web">{{competition?.Links?.Web}}</a>
    </div>


    <div class="social-media">
      <ng-container *ngIf="competition?.Links">
        <a [href]="competition?.Links['Facebook Official Page']" class="icon--facebook"
          *ngIf="competition?.Links['Facebook Official Page']">Facebook</a>
        <a [href]="competition?.Links['Twitter Account']" class="icon--twitter"
          *ngIf="competition?.Links['Twitter Account']">Twitter</a>
        <a [href]="competition?.Links['Instagram']" class="icon--instagram"
          *ngIf="competition?.Links['Instagram Account']">Instagram</a>
        <a [href]="competition?.Links['YouTube channel']" class="icon--youtube"
          *ngIf="competition?.Links['Youtube Account']">YouTube</a>
      </ng-container>
    </div>
  </div>
</div>
